import React from 'react'

// styles
import * as SC from './CheckboxStyles'

// types
import { CheckboxProps } from './types'

const Checkbox = (props: CheckboxProps) => {
	const { checked, onChange, onAfterChange, disabled, invalid, className, alignment = 'center', checkboxGap = 12, children } = props

	const onChangeWrap = (e: React.ChangeEvent<HTMLInputElement>) => {
		onChange(e)

		if (onAfterChange) {
			onAfterChange(e)
		}
	}

	return (
		<SC.CheckboxLabel $isInvalid={invalid} $checkboxGap={checkboxGap} $alignment={alignment} $disabled={disabled} className={className}>
			<SC.CheckboxInput $isInvalid={invalid} type={'checkbox'} checked={checked} onChange={onChangeWrap} disabled={disabled} />
			<SC.Checker $isInvalid={invalid} $alignment={alignment} />
			{children}
		</SC.CheckboxLabel>
	)
}

export default Checkbox
